<template>
  <div class="Multiple">
    <v-container grid-list-md fluid fill-height>
      <v-layout wrap align-start justify-center row fill-height>
        <v-flex xs12>
          <v-card v-if="questions.length > 0">
            <v-expansion-panel
              v-model="panel"
              expand
              popout
            >
              <v-expansion-panel-content>
                <template v-slot:header>
                  <v-card-title class="title">
                    Preguntas del operativo: {{ operName }}
                  </v-card-title>
                </template>

                <v-card>
                  <v-card-text>
                    <v-layout wrap align-center justify-space-between>
                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuIni"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Inicial"
                            v-model="dateIni"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser anterior a la fecha final"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateIni"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>

                      <v-flex xs12 md3>
                        <v-menu
                          :close-on-content-click="false"
                          v-model="menuEnd"
                          transition="scale-transition"
                          offset-y
                          full-width
                          :nudge-right="40"
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            label="Fecha Final"
                            v-model="dateEnd"
                            prepend-icon="event"
                            readonly
                            hint="Debe ser posterior a la fecha inicial"
                            persistent-hint
                          ></v-text-field>
                          <v-date-picker
                            v-model="dateEnd"
                            locale="es-CO"
                            no-title
                            scrollable
                            actions
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>

                      <v-spacer/>
                    </v-layout>

                    <v-layout wrap>
                      <v-flex xs12>
                        <v-layout row wrap v-for="i in reqs.length + 1" :key="i">
                          <v-flex xs12 md6 v-if="i<8">
                            <v-autocomplete
                              :items="questions"
                              label="Pregunta"
                              v-model="reqs[i-1]"
                              :disabled="loading"
                              color="secondary"
                              item-text="label"
                              return-object
                              hide-selected
                              hide-no-data
                              no-data-text="No se tienen Fields asociados a este operativo."
                            ></v-autocomplete>
                          </v-flex>

                          <v-flex xs12 md6 v-if="i<8">
                            <v-autocomplete
                              :items="options(i-1)"
                              label="Filtrar por Opcion de Respuesta"
                              v-model="opts[i-1]"
                              :disabled="loading"
                              chips
                              deletable-chips
                              color="secondary"
                              item-text="label"
                              item-value="id"
                              multiple
                              hide-selected
                              hide-no-data
                              hint="Vacio para no filtrar, por opciones de respuesta"
                            >
                              <template v-slot:append-outer>
                                <v-slide-x-reverse-transition
                                  mode="out-in"
                                >
                                  <v-icon
                                    color="error"
                                    @click="remove(i-1)"
                                    v-text="reqs[i-1] ? 'clear' : ' '"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </template>
                            </v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions class="mx-3">
                    <v-layout wrap align-center>
                      <v-flex xs12 md6>
                        <v-combobox
                          :items="savedReports"
                          label=" Reportes Guardados"
                          v-model="selectedReport"
                          :search-input.sync="search"
                          :disabled="loading"
                          color="secondary"
                          item-text="nombre"
                          return-object
                          no-data-text="No se tienen Reportes Guardados."
                          :progress="loading"
                        >
                          <template v-slot:no-data>
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-list-tile-title>
                                  No se encontro "<strong>{{ search }}</strong>".
                                  <kbd>Enter</kbd> y <kbd>+</kbd> para para Crear  y Agregarlo uno Nuevo.
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>

                          <template v-slot:append-outer>
                            <v-slide-x-reverse-transition
                              mode="out-in"
                            >
                              <v-icon large
                                v-if="typeof(selectedReport) === 'string' && selectedReport === search"
                                :disabled="loading || reqs.length < 1"
                                color="success"
                                @click="saveReport()"
                              >add</v-icon>
                            </v-slide-x-reverse-transition>

                            <v-slide-x-reverse-transition
                              mode="out-in"
                            >
                              <v-icon large
                                v-if="typeof(selectedReport) === 'object' && selectedReport !== null && selectedReport.nombre === search"
                                :disabled="loading"
                                color="info"
                                @click="saveReport()"
                              >edit</v-icon>
                            </v-slide-x-reverse-transition>

                            <v-slide-x-reverse-transition
                              mode="out-in"
                            >
                              <v-icon large
                                v-if="typeof(selectedReport) === 'object' && selectedReport !== null && selectedReport.nombre === search"
                                :disabled="loading"
                                color="error"
                                @click="deleteReport()"
                              >clear</v-icon>
                            </v-slide-x-reverse-transition>
                          </template>
                        </v-combobox>
                      </v-flex>

                      <v-flex xs12 md6>
                        <v-switch
                        v-model="efectivo"
                        label= 'efectivos'
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="warning"
                :disabled="loading"
                @click="clear()"
              >
                Limpiar
              </v-btn>
              <v-btn color="info"
                :disabled="loading || vDate"
                @click="reply()"
              >
                Generar Reporte
              </v-btn>
            </v-card-actions>
          </v-card>

          <v-card v-else>
            <v-alert type="info" :value="true" icon="new_releases">
              No se tienen Fields asociados a este operativo
            </v-alert>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="loading">
          <v-card>
            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                class="text-xs-center"
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-else>
          <report-multiple
            :data="data"
            :csvname="csvname"
            :questionsShow="questionsShow"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import reportMultiple from '@/components/Multiple'

export default {
  name: `Multiple`,

  components: {
    'report-multiple': reportMultiple
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.operName = this.$store.state.actualOperation.nombre_operativo
    this.getQuestions()
    this.getSavedReports()
  },

  data: function () {
    return {
      backConf: {
        path: '/formularios/reporte/',
        pathUpload: '/formularios/savereporte/',
        page: 1
      },

      operativo: null,
      operName: null,

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      panel: [true],
      selectedReport: null,
      savedReports: [],

      dateIni: null,
      dateEnd: null,

      questions: [],

      reqs: [],
      reqsOld: [],
      opts: [],
      search: null,

      efectivo: true,

      data: [],
      csvname: 'Respuestas.csv',
      questionsShow: ''
    }
  },

  watch: {
    /**
     * Verifica la longitud de la lista de preguntas,
     * evitando superar el limite de 5
     */
    reqs: function () {
      if (this.reqs.length > 7) {
        this.reqs.pop()
      }

      for (let i = 0; i < this.reqsOld.length; i++) {
        if (this.reqs[i].id !== this.reqsOld[i].id) {
          this.opts[i] = []
        }
      }

      this.reqsOld = this.reqs.slice()
    },

    selectedReport: function () {
      if (typeof (this.selectedReport) === 'object' && this.selectedReport !== null) {
        this.reqsOld = []
        this.reqs = this.selectedReport.data.reqs
        this.opts = this.selectedReport.data.opts
      }
    }
  },

  computed: {
    /**
     * Verifica que la fecha final no sea anterior a la fecha inicial
     */
    vDate: function vDate () {
      if (this.dateIni && this.dateEnd) {
        return moment(this.dateEnd).isBefore(this.dateIni)
      }
      return false
    },

    /**
     * Crea el Json para la consulta
     */
    dataQuery: function dataQuery () {
      let questions = {}

      for (let i = 0; i < this.reqs.length; i++) {
        questions[this.reqs[i].id] = this.opts[i] ? this.opts[i] : []
      }

      return questions
    },

    /**
     * Genera el nombre de las preguntas y su clave para el reporte guardado
     * @return {string} Cadena de texto con las claves y los valores
     */
    queryQuestions: function () {
      let qq = ''
      this.reqs.forEach(function (req) {
        qq += req.id + ': ' + req.label + '<br>'
      })

      return qq
    }
  },

  methods: {
    /**
     * Obtiene la lista de preguntas para el operativo
     */
    getQuestions () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.questions = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.questions = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Obtiene las respuestas de la pregunta solicitada
     */
    reply () {
      this.loading = true
      this.panel = [false]

      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          data: this.dataQuery,
          fecha_i: this.dateIni,
          fecha_f: this.dateEnd,
          efectivo: this.efectivo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.data = resp.data
          t.csvname = t.name()
          t.questionsShow = t.queryQuestions
          t.selectedReport = null
          t.loading = false
        })
        .catch(function (err) {
          t.data = []
          t.selectedReport = null
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Determina el nombre para el csv.
     * Si se tiene seleccionada solo una el csv tendra ese nombre
     * Si se tiene seleccionada mas de una, el nombre sera Reporte Multiple
     */
    name () {
      if (this.reqs) {
        if (this.reqs.length < 2) {
          return this.reqs[0].label + '.csv'
        } else {
          let quest = 'Reporte Multiple ('
          quest += this.reqs.map(q => q.label)
          return quest + ').csv'
        }
      }

      return 'Respuestas.csv'
    },

    /**
     * Retorna la lista de opciones para la pregunta seleccionada
     * @param  {int} index el indice de la pregunta seleccionada, en el arreglo de seleccion
     * @return {array}     los choices correspondientes a esa pregunta
     */
    options (index) {
      if (this.reqs[index]) {
        return this.reqs[index].choices
      }
      return []
    },

    /**
     * Limpia todos los campos
     */
    clear () {
      this.reqs = []
      this.reqsOld = []
      this.opts = []
      // this.reportName = ''
      this.selectedReport = null
      this.dateIni = null
      this.dateEnd = null
      this.panel = [true]
    },

    /**
     * Retira el elemento de la lista
     * @param  {int} index el indice de la pregunta seleccionada
     * @return {array}     el array sin el elemento
     */
    remove (index) {
      this.reqs.splice(index, 1)
      this.reqsOld.splice(index, 1)
      this.opts.splice(index, 1)
    },

    /**
     * Guarda una consulta como reporte
     */
    saveReport () {
      this.loading = true

      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          nombre: typeof (this.selectedReport) === 'object' ? this.selectedReport.nombre : this.selectedReport,
          data: {
            questions: this.queryQuestions,
            query: this.dataQuery,
            reqs: this.reqs,
            opts: this.opts
          }
        },
        url: this.backConf.pathUpload
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.getSavedReports()
          t.selectedReport = null
          t.loading = false
        })
        .catch(function (err) {
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Obtiene la lista de reportes guardados
     */
    getSavedReports () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.pathUpload
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.savedReports = resp.data
          t.loading = false
        })
        .catch(function (err) {
          t.savedReports = null
          t.loading = false
          console.error(err)
        })
    },

    deleteReport () {
      this.loading = true

      let request = {
        method: 'delete',
        data: {
          operativo: this.operativo,
          nombre: this.selectedReport.nombre
        },
        url: this.backConf.pathUpload
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.getSavedReports()
          t.selectedReport = null
          t.loading = false
        })
        .catch(function (err) {
          t.loading = false
          console.error(err)
        })
    }
  }
}
</script>
